import React from 'react';
import { FormControl } from '@material-ui/core';
import { Controller, useFormContext } from 'react-hook-form';
import useReactHookFormStyles from '../../../../custom-components/form-components/ReactHookForm.styles';
import GeofenceManager from '../../../../custom-components/geofences/maps/GeofenceManager/GeofenceManager';
import { getShapeCenter } from '../../../../custom-components/geofences/maps/GeofenceManager/GeofenceManager.helpers';

const buildFilterParams = ({ site_type, hauler_yard_id, wash_facility_id, user_id }) => {
    const filterParams = {
        site_type,
    };
    switch (site_type) {
        case 'haulerYard':
            filterParams.hauler_yard_id = hauler_yard_id;
            filterParams.user_id = user_id;
            break;
        case 'washFacility':
            // wash facility geofences are linked directly to the wash facility and no user
            filterParams.wash_facility_id = wash_facility_id;
            break;
        case 'primary':
        default:
            filterParams.user_id = user_id;
            break;
    }

    return filterParams;
};

const getIsEditing = ({ site_type, hauler_yard_id, wash_facility_id, user_id }) => {
    switch (site_type) {
        case 'haulerYard':
            return !!hauler_yard_id;
        case 'washFacility':
            return !!wash_facility_id;
        case 'primary':
        default:
            return !!user_id;
    }
};

const assignId = ({ id, site_type }) => {
    switch (site_type) {
        case 'haulerYard':
            return { hauler_yard_id: id };
        case 'washFacility':
            return { wash_facility_id: id };
        case 'primary':
        default:
            return { user_id: id };
    }
};

const getUserId = ({ getValues, siteType = 'primary', userIdField }) => {
    if (siteType === 'primary') {
        return getValues('id');
    }
    if (!userIdField) {
        return null;
    }
    return getValues(userIdField);
};

const Geofence = ({ name, props, filterParams }) => {
    const classes = useReactHookFormStyles();
    const { control, getValues, setValue } = useFormContext();
    const { addressField, userIdField, siteType = 'primary' } = props;

    const user_id = getUserId({ getValues, siteType, userIdField });

    const user_name = getValues('name');
    const site_type = siteType ?? 'primary';
    const _id = getValues('_id');

    const { hauler_yard_id, wash_facility_id } = assignId({ id: _id, site_type });

    const address = addressField ? getValues(addressField) : null;
    const hasLatLng = getValues('latitude') && getValues('longitude');
    const center = hasLatLng ? { lat: getValues('latitude'), lng: getValues('longitude') } : props.center;

    const updateLatLong = (newGeofence) => {
        const { lat, lng } = getShapeCenter(newGeofence);

        setValue('latitude', lat.toString());
        setValue('longitude', lng.toString());
        setValue('site_type', site_type);
    };

    return (
        <FormControl className={classes.formController}>
            <Controller
                control={control}
                name={name}
                render={({ field: { onChange } }) => (
                    <GeofenceManager
                        {...props}
                        center={center}
                        user_id={user_id}
                        isEditing={getIsEditing({ site_type, hauler_yard_id, wash_facility_id, user_id })}
                        user_name={user_name}
                        filterParams={buildFilterParams({ site_type, hauler_yard_id, wash_facility_id, user_id })}
                        onChange={(newGeofence) => {
                            updateLatLong(newGeofence[0]);
                            onChange(newGeofence[0]);
                        }}
                        address={address}
                        // wrap
                    />
                )}
            />
        </FormControl>
    );
};

export default Geofence;
